<template>
    <div class="tableRecepcion">
        <table class="table table-responsive-lg table-striped table-bordered">
            <thead class="thead-dark">
                <tr>
                    <th v-for="column in columns">{{column}}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                        <i class="entypo entypo-eye" @click="abrirModal"></i>
                        <i class="entypo entypo-pencil"></i>
                    </td>
                </tr>
            </tbody>
        </table>
        <vuestic-modal :show.sync="show" v-bind:large="true" ref="largeModal">

        </vuestic-modal>
    </div>
</template>

<script>
  import VuesticModal from "../../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";
  export default {
    name: 'tableRecepcion',
      components: {VuesticModal},
      data(){
      return{
        columns:['Fecha', 'Folio', 'Tipo Documento','Proveedor'
          ,'Transporte','O/T',' Bultos','Acciones'],

        show:false
      }
    },
      methods:{
        abrirModal(){
            this.$refs.largeModal.open()
        }
      }
  }
</script>

<style scoped>
    i{
        margin: 10px;
        cursor: pointer;
    }
</style>
